enum HomePage {
  NOTES = 'notes',
  DISEASE_RISK = 'disease-risk',
  TIMELINE = 'timeline',
  NEMADIGITAL_MAP_VIEW = 'nemadigital/map-view'
}

enum EventName {
  OPEN_NOTES = 'Open Notes',
  OPEN_DISEASE_RISK = 'Open Disease Risk',
  OPEN_TIMELINE = 'Open Timeline',
  OPEN_NEMADIGITAL_MAP_VIEW = 'Open NemaDigital Map View'
}

const homePageMapping = {
  showOnlyNotesFeature: { eventName: EventName.OPEN_NOTES, page: HomePage.NOTES },
  hasDiseaseRiskLandingPage: { eventName: EventName.OPEN_DISEASE_RISK, page: HomePage.DISEASE_RISK },
  hasNemaPlanWithoutProtector: { eventName: EventName.OPEN_NEMADIGITAL_MAP_VIEW, page: HomePage.NEMADIGITAL_MAP_VIEW },
  default: { eventName: EventName.OPEN_TIMELINE, page: HomePage.TIMELINE }
};

interface GetHomePageProps {
  hasDiseaseRiskLandingPage: boolean;
  showOnlyNotesFeature: boolean;
  hasNemaPlanWithoutProtector: boolean;
}

export const getHomePage = ({ hasDiseaseRiskLandingPage, showOnlyNotesFeature, hasNemaPlanWithoutProtector }: GetHomePageProps) => {
  if (hasNemaPlanWithoutProtector) {
    return homePageMapping.hasNemaPlanWithoutProtector;
  }
  if (showOnlyNotesFeature) {
    return homePageMapping.showOnlyNotesFeature;
  }
  if (hasDiseaseRiskLandingPage) {
    return homePageMapping.hasDiseaseRiskLandingPage;
  }
  return homePageMapping.default;
};
